const dataExample = {
  region: 7,
  data: [
    [
      'id',
      'disease',
      'city',
      'cd_mun',
      'cd_micro',
      'nm_micro',
      'cd_meso',
      'nm_meso',
    ],
    [
      1,
      'HAC',
      'Candelária',
      4304200,
      43020,
      'Santa Cruz do Sul',
      4304,
      'Centro Oriental Rio-grandense',
    ],
    [
      2,
      'HAC',
      'Lagoa Vermelha',
      4311304,
      43015,
      'Vacaria',
      4302,
      'Nordeste Rio-grandense',
    ],
    [
      3,
      'HAC',
      'Formigueiro',
      4308409,
      43019,
      'Restinga Seca',
      4303,
      'Centro Ocidental Rio-grandense',
    ],
    [
      4,
      'HAC',
      'Caçapava do Sul',
      4302808,
      43032,
      'Serras de Sudeste',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      5,
      'HAC',
      'Morro Reuter',
      4312476,
      43024,
      'Gramado-Canela',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      6,
      'HAC',
      'Estrela',
      4307807,
      43021,
      'Lajeado-Estrela',
      4304,
      'Centro Oriental Rio-grandense',
    ],
    [
      7,
      'HAC',
      'Veranópolis',
      4322806,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
    ],
    [
      8,
      'HAC',
      'São João do Polêsine',
      4318432,
      43019,
      'Restinga Seca',
      4303,
      'Centro Ocidental Rio-grandense',
    ],
    [
      9,
      'HAC',
      'Progresso',
      4315156,
      43021,
      'Lajeado-Estrela',
      4304,
      'Centro Oriental Rio-grandense',
    ],
    [
      10,
      'HAC',
      'Farroupilha',
      4307906,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
    ],
    [
      11,
      'HAC',
      'Vacaria',
      4322509,
      43015,
      'Vacaria',
      4302,
      'Nordeste Rio-grandense',
    ],
    [
      12,
      'HAC',
      'Alvorada',
      4300604,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      13,
      'HAC',
      'Eldorado do Sul',
      4306767,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      14,
      'HAC',
      'Teutônia',
      4321451,
      43021,
      'Lajeado-Estrela',
      4304,
      'Centro Oriental Rio-grandense',
    ],
    [
      15,
      'HAC',
      'Santa Cruz do Sul',
      4316808,
      43020,
      'Santa Cruz do Sul',
      4304,
      'Centro Oriental Rio-grandense',
    ],
    [
      16,
      'HAC',
      'Machadinho',
      4311700,
      43005,
      'Sananduva',
      4301,
      'Noroeste Rio-grandense',
    ],
    [
      17,
      'HAC',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      18,
      'HAC',
      'Bagé',
      4301602,
      43031,
      'Campanha Meridional',
      4306,
      'Sudoeste Rio-grandense',
    ],
    [
      19,
      'HAC',
      'Rio Grande',
      4315602,
      43035,
      'Litoral Lagunar',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      20,
      'HAC',
      'São Luiz Gonzaga',
      4318903,
      43007,
      'Santo Ângelo',
      4301,
      'Noroeste Rio-grandense',
    ],
    [
      21,
      'HAC',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      22,
      'HAC',
      'Estrela',
      4307807,
      43021,
      'Lajeado-Estrela',
      4304,
      'Centro Oriental Rio-grandense',
    ],
    [
      23,
      'HAC',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      24,
      'HAC',
      'Estrela',
      4307807,
      43021,
      'Lajeado-Estrela',
      4304,
      'Centro Oriental Rio-grandense',
    ],
    [
      25,
      'HAC',
      'Cachoeirinha',
      4303103,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      26,
      'HAC',
      'Gravataí',
      4309209,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      27,
      'HAC',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      28,
      'HAC',
      'Arroio do Sal',
      4301057,
      43027,
      'Osório',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      29,
      'HAC',
      'Arroio do Sal',
      4301057,
      43027,
      'Osório',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      30,
      'HAC',
      'Santa Maria',
      4316907,
      43018,
      'Santa Maria',
      4303,
      'Centro Ocidental Rio-grandense',
    ],
    [
      31,
      'HAC',
      'Três Passos',
      4321907,
      43002,
      'Três Passos',
      4301,
      'Noroeste Rio-grandense',
    ],
    [
      32,
      'HAC',
      'Eldorado do Sul',
      4306767,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      33,
      'HAC',
      'Rio Grande',
      4315602,
      43035,
      'Litoral Lagunar',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      34,
      'HAC',
      'Coronel Bicaco',
      4305900,
      43008,
      'Ijuí',
      4301,
      'Noroeste Rio-grandense',
    ],
    [
      35,
      'HAC',
      'Bagé',
      4301602,
      43031,
      'Campanha Meridional',
      4306,
      'Sudoeste Rio-grandense',
    ],
    [
      36,
      'HAC',
      'São Sebastião do Caí',
      4319505,
      43023,
      'Montenegro',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      37,
      'FC',
      'Viamão',
      4323002,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      38,
      'FC',
      'Santa Rosa',
      4317202,
      43001,
      'Santa Rosa',
      4301,
      'Noroeste Rio-grandense',
    ],
    [
      39,
      'FC',
      'Três Cachoeiras',
      4321667,
      43027,
      'Osório',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      40,
      'FC',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      41,
      'FC',
      'Cerro Grande do Sul',
      4305173,
      43028,
      'Camaquã',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      42,
      'FC',
      'Igrejinha',
      4310108,
      43024,
      'Gramado-Canela',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      43,
      'FC',
      'Canoas',
      4304606,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      44,
      'FC',
      'Capivari do Sul',
      4304671,
      43027,
      'Osório',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      45,
      'FC',
      'Roque Gonzales',
      4316303,
      43006,
      'Cerro Largo',
      4301,
      'Noroeste Rio-grandense',
    ],
    [
      46,
      'FC',
      'Salto do Jacuí',
      4316451,
      43011,
      'Cruz Alta',
      4301,
      'Noroeste Rio-grandense',
    ],
    [
      47,
      'FC',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      48,
      'FC',
      'Sapiranga',
      4319901,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      49,
      'FC',
      'Passo Fundo',
      4314100,
      43010,
      'Passo Fundo',
      4301,
      'Noroeste Rio-grandense',
    ],
    [
      50,
      'FC',
      'Carazinho',
      4304705,
      43009,
      'Carazinho',
      4301,
      'Noroeste Rio-grandense',
    ],
    [
      51,
      'FC',
      'Panambi',
      4313904,
      43008,
      'Ijuí',
      4301,
      'Noroeste Rio-grandense',
    ],
    [
      52,
      'FC',
      'Pelotas',
      4314407,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      53,
      'FC',
      'Pelotas',
      4314407,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      54,
      'FC',
      'Ibirubá',
      4310009,
      43011,
      'Cruz Alta',
      4301,
      'Noroeste Rio-grandense',
    ],
    [
      55,
      'FC',
      'Nova Bréscia',
      4313003,
      43021,
      'Lajeado-Estrela',
      4304,
      'Centro Oriental Rio-grandense',
    ],
    [
      56,
      'FC',
      'Guaíba',
      4309308,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      57,
      'FC',
      'Harmonia',
      4309555,
      43023,
      'Montenegro',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      58,
      'FC',
      'Osório',
      4313508,
      43027,
      'Osório',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      59,
      'FC',
      'Novo Hamburgo',
      4313409,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      60,
      'FC',
      'São Pedro das Missões',
      4319364,
      43009,
      'Carazinho',
      4301,
      'Noroeste Rio-grandense',
    ],
    [
      61,
      'FC',
      'Osório',
      4313508,
      43027,
      'Osório',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      62,
      'FC',
      'Nova Ramada',
      4313334,
      43008,
      'Ijuí',
      4301,
      'Noroeste Rio-grandense',
    ],
    [
      63,
      'FC',
      'Passa Sete',
      4314068,
      43020,
      'Santa Cruz do Sul',
      4304,
      'Centro Oriental Rio-grandense',
    ],
    [
      64,
      'FC',
      'Alvorada',
      4300604,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      65,
      'FC',
      'Cambará do Sul',
      4303608,
      43015,
      'Vacaria',
      4302,
      'Nordeste Rio-grandense',
    ],
    [
      66,
      'FC',
      'Encantado',
      4306809,
      43021,
      'Lajeado-Estrela',
      4304,
      'Centro Oriental Rio-grandense',
    ],
    [
      67,
      'FC',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      68,
      'FC',
      'Dois Irmãos',
      4306403,
      43024,
      'Gramado-Canela',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      69,
      'FC',
      'Gravataí',
      4309209,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      70,
      'FC',
      'Igrejinha',
      4310108,
      43024,
      'Gramado-Canela',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      71,
      'FC',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      72,
      'FC',
      'Estância Velha',
      4307609,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      73,
      'FC',
      'Passo Fundo',
      4314100,
      43010,
      'Passo Fundo',
      4301,
      'Noroeste Rio-grandense',
    ],
    [
      74,
      'FC',
      'São Leopoldo',
      4318705,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      75,
      'FC',
      'Canela',
      4304408,
      43024,
      'Gramado-Canela',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      76,
      'FC',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      77,
      'FC',
      'Gravataí',
      4309209,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      78,
      'FC',
      'Passo Fundo',
      4314100,
      43010,
      'Passo Fundo',
      4301,
      'Noroeste Rio-grandense',
    ],
    [
      79,
      'FC',
      'Caxias do Sul',
      4305108,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
    ],
    [
      80,
      'FC',
      'Passo Fundo',
      4314100,
      43010,
      'Passo Fundo',
      4301,
      'Noroeste Rio-grandense',
    ],
    [
      81,
      'FC',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      82,
      'FC',
      'Novo Hamburgo',
      4313409,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      83,
      'FC',
      'Canoas',
      4304606,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      84,
      'FC',
      'Três Passos',
      4321907,
      43002,
      'Três Passos',
      4301,
      'Noroeste Rio-grandense',
    ],
    [
      85,
      'FC',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      86,
      'FC',
      'Vera Cruz',
      4322707,
      43020,
      'Santa Cruz do Sul',
      4304,
      'Centro Oriental Rio-grandense',
    ],
    [
      87,
      'FC',
      'São José do Ouro',
      4318606,
      43005,
      'Sananduva',
      4301,
      'Noroeste Rio-grandense',
    ],
    [
      88,
      'FC',
      'Canguçu',
      4304507,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      89,
      'FC',
      'Venâncio Aires',
      4322608,
      43020,
      'Santa Cruz do Sul',
      4304,
      'Centro Oriental Rio-grandense',
    ],
    [
      90,
      'FC',
      'Novo Hamburgo',
      4313409,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      91,
      'FC',
      'Canoas',
      4304606,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      92,
      'FC',
      'Bento Gonçalves',
      4302105,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
    ],
    [
      93,
      'FC',
      'Osório',
      4313508,
      43027,
      'Osório',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      94,
      'FC',
      'Vacaria',
      4322509,
      43015,
      'Vacaria',
      4302,
      'Nordeste Rio-grandense',
    ],
    [
      95,
      'FC',
      'Lajeado',
      4311403,
      43021,
      'Lajeado-Estrela',
      4304,
      'Centro Oriental Rio-grandense',
    ],
    [
      96,
      'FC',
      'Três de Maio',
      4321808,
      43001,
      'Santa Rosa',
      4301,
      'Noroeste Rio-grandense',
    ],
    [
      97,
      'FC',
      'Pinheiro Machado',
      4314506,
      43032,
      'Serras de Sudeste',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      98,
      'FC',
      'Gravataí',
      4309209,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      99,
      'FC',
      'São Leopoldo',
      4318705,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      100,
      'FC',
      'Panambi',
      4313904,
      43008,
      'Ijuí',
      4301,
      'Noroeste Rio-grandense',
    ],
    [
      101,
      'FC',
      'Sananduva',
      4316600,
      43005,
      'Sananduva',
      4301,
      'Noroeste Rio-grandense',
    ],
    [
      102,
      'FC',
      'Butiá',
      4302709,
      43025,
      'São Jerônimo',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      103,
      'FC',
      'Canela',
      4304408,
      43024,
      'Gramado-Canela',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      104,
      'FC',
      'São Jorge',
      4318440,
      43014,
      'Guaporé',
      4302,
      'Nordeste Rio-grandense',
    ],
    [
      105,
      'FC',
      'Bagé',
      4301602,
      43031,
      'Campanha Meridional',
      4306,
      'Sudoeste Rio-grandense',
    ],
    [
      106,
      'FC',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      107,
      'FC',
      'Viamão',
      4323002,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      108,
      'FC',
      'Rosário do Sul',
      4316402,
      43030,
      'Campanha Central',
      4306,
      'Sudoeste Rio-grandense',
    ],
    [
      109,
      'FC',
      'Santa Maria',
      4316907,
      43018,
      'Santa Maria',
      4303,
      'Centro Ocidental Rio-grandense',
    ],
    [
      110,
      'FC',
      'Passo Fundo',
      4314100,
      43010,
      'Passo Fundo',
      4301,
      'Noroeste Rio-grandense',
    ],
    [
      111,
      'FC',
      'Três de Maio',
      4321808,
      43001,
      'Santa Rosa',
      4301,
      'Noroeste Rio-grandense',
    ],
    [
      112,
      'FC',
      'Canguçu',
      4304507,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      113,
      'FC',
      'Santo Ângelo',
      4317509,
      43007,
      'Santo Ângelo',
      4301,
      'Noroeste Rio-grandense',
    ],
    [
      114,
      'Hb',
      'Guaíba',
      4309308,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      115,
      'Hb',
      'Estância Velha',
      4307609,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      116,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      117,
      'Hb',
      'Uruguaiana',
      4322400,
      43029,
      'Campanha Ocidental',
      4306,
      'Sudoeste Rio-grandense',
    ],
    [
      118,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      119,
      'Hb',
      'Campo Novo',
      4304002,
      43002,
      'Três Passos',
      4301,
      'Noroeste Rio-grandense',
    ],
    [
      120,
      'Hb',
      'Palmitinho',
      4313805,
      43003,
      'Frederico Westphalen',
      4301,
      'Noroeste Rio-grandense',
    ],
    [
      121,
      'Hb',
      'Alvorada',
      4300604,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      122,
      'Hb',
      'Pelotas',
      4314407,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      123,
      'Hb',
      'Charqueadas',
      4305355,
      43025,
      'São Jerônimo',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      124,
      'Hb',
      'Boqueirão do Leão',
      4302451,
      43021,
      'Lajeado-Estrela',
      4304,
      'Centro Oriental Rio-grandense',
    ],
    [
      125,
      'Hb',
      'Entre Rios do Sul',
      4306957,
      43004,
      'Erechim',
      4301,
      'Noroeste Rio-grandense',
    ],
    [
      126,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      127,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      128,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      129,
      'Hb',
      'Santa Maria',
      4316907,
      43018,
      'Santa Maria',
      4303,
      'Centro Ocidental Rio-grandense',
    ],
    [
      130,
      'Hb',
      'São Gabriel',
      4318309,
      43030,
      'Campanha Central',
      4306,
      'Sudoeste Rio-grandense',
    ],
    [
      131,
      'Hb',
      'Glorinha',
      4309050,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      132,
      'Hb',
      'Santa Cruz do Sul',
      4316808,
      43020,
      'Santa Cruz do Sul',
      4304,
      'Centro Oriental Rio-grandense',
    ],
    [
      133,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      134,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      135,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      136,
      'Hb',
      'Condor',
      4305702,
      43008,
      'Ijuí',
      4301,
      'Noroeste Rio-grandense',
    ],
    [
      137,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      138,
      'Hb',
      'Alvorada',
      4300604,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      139,
      'Hb',
      'Cruzeiro do Sul',
      4306205,
      43021,
      'Lajeado-Estrela',
      4304,
      'Centro Oriental Rio-grandense',
    ],
    [
      140,
      'Hb',
      'São Leopoldo',
      4318705,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      141,
      'Hb',
      'Pelotas',
      4314407,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      142,
      'Hb',
      'Pelotas',
      4314407,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      143,
      'Hb',
      'Minas do Leão',
      4312252,
      43025,
      'São Jerônimo',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      144,
      'Hb',
      'Venâncio Aires',
      4322608,
      43020,
      'Santa Cruz do Sul',
      4304,
      'Centro Oriental Rio-grandense',
    ],
    [
      145,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      146,
      'Hb',
      'Bagé',
      4301602,
      43031,
      'Campanha Meridional',
      4306,
      'Sudoeste Rio-grandense',
    ],
    [
      147,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      148,
      'Hb',
      'São Jerônimo',
      4318408,
      43025,
      'São Jerônimo',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      149,
      'Hb',
      'Sapucaia do Sul',
      4320008,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      150,
      'Hb',
      'Rio Grande',
      4315602,
      43035,
      'Litoral Lagunar',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      151,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      152,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      153,
      'Hb',
      'Viamão',
      4323002,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      154,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      155,
      'Hb',
      'Tupanciretã',
      4322202,
      43017,
      'Santiago',
      4303,
      'Centro Ocidental Rio-grandense',
    ],
    [
      156,
      'Hb',
      'Bento Gonçalves',
      4302105,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
    ],
    [
      157,
      'Hb',
      'Alvorada',
      4300604,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      158,
      'Hb',
      'Estrela',
      4307807,
      43021,
      'Lajeado-Estrela',
      4304,
      'Centro Oriental Rio-grandense',
    ],
    [
      159,
      'Hb',
      'Pelotas',
      4314407,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      160,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      161,
      'Hb',
      'Alvorada',
      4300604,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      162,
      'Hb',
      'Viamão',
      4323002,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      163,
      'Hb',
      'Rio Grande',
      4315602,
      43035,
      'Litoral Lagunar',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      164,
      'Hb',
      'Santa Maria',
      4316907,
      43018,
      'Santa Maria',
      4303,
      'Centro Ocidental Rio-grandense',
    ],
    [
      165,
      'Hb',
      'Rio Grande',
      4315602,
      43035,
      'Litoral Lagunar',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      166,
      'Hb',
      'Pontão',
      4314779,
      43010,
      'Passo Fundo',
      4301,
      'Noroeste Rio-grandense',
    ],
    [
      167,
      'Hb',
      'Mariano Moro',
      4312005,
      43004,
      'Erechim',
      4301,
      'Noroeste Rio-grandense',
    ],
    [
      168,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      169,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      170,
      'Hb',
      'Canoas',
      4304606,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      171,
      'Hb',
      'Formigueiro',
      4308409,
      43019,
      'Restinga Seca',
      4303,
      'Centro Ocidental Rio-grandense',
    ],
    [
      172,
      'Hb',
      'Santana do Livramento',
      4317103,
      43030,
      'Campanha Central',
      4306,
      'Sudoeste Rio-grandense',
    ],
    [
      173,
      'Hb',
      'Fontoura Xavier',
      4308300,
      43013,
      'Soledade',
      4301,
      'Noroeste Rio-grandense',
    ],
    [
      174,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      175,
      'Hb',
      'Alvorada',
      4300604,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      176,
      'Hb',
      'Guaíba',
      4309308,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      177,
      'Hb',
      'Passo Fundo',
      4314100,
      43010,
      'Passo Fundo',
      4301,
      'Noroeste Rio-grandense',
    ],
    [
      178,
      'Hb',
      'Pelotas',
      4314407,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      179,
      'Hb',
      'Barra do Ribeiro',
      4301909,
      43028,
      'Camaquã',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      180,
      'Hb',
      'Pelotas',
      4314407,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      181,
      'Hb',
      'Uruguaiana',
      4322400,
      43029,
      'Campanha Ocidental',
      4306,
      'Sudoeste Rio-grandense',
    ],
    [
      182,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      183,
      'Hb',
      'Pantano Grande',
      4313953,
      43022,
      'Cachoeira do Sul',
      4304,
      'Centro Oriental Rio-grandense',
    ],
    [
      184,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      185,
      'Hb',
      'Alvorada',
      4300604,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      186,
      'Hb',
      'Viamão',
      4323002,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      187,
      'Hb',
      'Uruguaiana',
      4322400,
      43029,
      'Campanha Ocidental',
      4306,
      'Sudoeste Rio-grandense',
    ],
    [
      188,
      'Hb',
      'Pelotas',
      4314407,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      189,
      'Hb',
      'Gravataí',
      4309209,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      190,
      'Hb',
      'Alvorada',
      4300604,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      191,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      192,
      'Hb',
      'Rio Grande',
      4315602,
      43035,
      'Litoral Lagunar',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      193,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      194,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      195,
      'Hb',
      'Alvorada',
      4300604,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      196,
      'Hb',
      'Montenegro',
      4312401,
      43023,
      'Montenegro',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      197,
      'Hb',
      'São Gabriel',
      4318309,
      43030,
      'Campanha Central',
      4306,
      'Sudoeste Rio-grandense',
    ],
    [
      198,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      199,
      'Hb',
      'Capela de Santana',
      4304689,
      43023,
      'Montenegro',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      200,
      'Hb',
      'Fontoura Xavier',
      4308300,
      43013,
      'Soledade',
      4301,
      'Noroeste Rio-grandense',
    ],
    [
      201,
      'Hb',
      'Santa Cruz do Sul',
      4316808,
      43020,
      'Santa Cruz do Sul',
      4304,
      'Centro Oriental Rio-grandense',
    ],
    [
      202,
      'Hb',
      'Santana do Livramento',
      4317103,
      43030,
      'Campanha Central',
      4306,
      'Sudoeste Rio-grandense',
    ],
    [
      203,
      'Hb',
      'Cachoeira do Sul',
      4303004,
      43022,
      'Cachoeira do Sul',
      4304,
      'Centro Oriental Rio-grandense',
    ],
    [
      204,
      'Hb',
      'Estância Velha',
      4307609,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      205,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      206,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      207,
      'Hb',
      'Caçapava do Sul',
      4302808,
      43032,
      'Serras de Sudeste',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      208,
      'Hb',
      'Bagé',
      4301602,
      43031,
      'Campanha Meridional',
      4306,
      'Sudoeste Rio-grandense',
    ],
    [
      209,
      'Hb',
      'Júlio de Castilhos',
      4311205,
      43017,
      'Santiago',
      4303,
      'Centro Ocidental Rio-grandense',
    ],
    [
      210,
      'Hb',
      'Viamão',
      4323002,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      211,
      'Hb',
      'São Gabriel',
      4318309,
      43030,
      'Campanha Central',
      4306,
      'Sudoeste Rio-grandense',
    ],
    [
      212,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      213,
      'Hb',
      'Alvorada',
      4300604,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      214,
      'Hb',
      'Bagé',
      4301602,
      43031,
      'Campanha Meridional',
      4306,
      'Sudoeste Rio-grandense',
    ],
    [
      215,
      'Hb',
      'Sapucaia do Sul',
      4320008,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      216,
      'Hb',
      'Rio Grande',
      4315602,
      43035,
      'Litoral Lagunar',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      217,
      'Hb',
      'Arroio dos Ratos',
      4301107,
      43025,
      'São Jerônimo',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      218,
      'Hb',
      'Pelotas',
      4314407,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      219,
      'Hb',
      'Santana do Livramento',
      4317103,
      43030,
      'Campanha Central',
      4306,
      'Sudoeste Rio-grandense',
    ],
    [
      220,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      221,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      222,
      'Hb',
      'São José do Norte',
      4318507,
      43035,
      'Litoral Lagunar',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      223,
      'Hb',
      'Alvorada',
      4300604,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      224,
      'Hb',
      'Ipê',
      4310439,
      43015,
      'Vacaria',
      4302,
      'Nordeste Rio-grandense',
    ],
    [
      225,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      226,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      227,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      228,
      'Hb',
      'Canoas',
      4304606,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      229,
      'Hb',
      'Alvorada',
      4300604,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      230,
      'Hb',
      'Canoas',
      4304606,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      231,
      'Hb',
      'Viamão',
      4323002,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      232,
      'Hb',
      'Guaíba',
      4309308,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [233, 'Hb', 'Ijuí', 4310207, 43008, 'Ijuí', 4301, 'Noroeste Rio-grandense'],
    [
      234,
      'Hb',
      'Capão do Leão',
      4304663,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      235,
      'Hb',
      'Canoas',
      4304606,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      236,
      'Hb',
      'Caxias do Sul',
      4305108,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
    ],
    [
      237,
      'Hb',
      'Viamão',
      4323002,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      238,
      'Hb',
      'Guaíba',
      4309308,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      239,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      240,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      241,
      'Hb',
      'Pelotas',
      4314407,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      242,
      'Hb',
      'Alvorada',
      4300604,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      243,
      'Hb',
      'Rio Grande',
      4315602,
      43035,
      'Litoral Lagunar',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      244,
      'Hb',
      'Canela',
      4304408,
      43024,
      'Gramado-Canela',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      245,
      'Hb',
      'Tabaí',
      4320859,
      43021,
      'Lajeado-Estrela',
      4304,
      'Centro Oriental Rio-grandense',
    ],
    [
      246,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      247,
      'Hb',
      'Vacaria',
      4322509,
      43015,
      'Vacaria',
      4302,
      'Nordeste Rio-grandense',
    ],
    [
      248,
      'Hb',
      'Santo Antônio da Patrulha',
      4317608,
      43027,
      'Osório',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      249,
      'Hb',
      'Pelotas',
      4314407,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      250,
      'Hb',
      'Pelotas',
      4314407,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      251,
      'Hb',
      'Eldorado do Sul',
      4306767,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      252,
      'Hb',
      'Alvorada',
      4300604,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      253,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      254,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      255,
      'Hb',
      'Bento Gonçalves',
      4302105,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
    ],
    [
      256,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      257,
      'Hb',
      'Alegrete',
      4300406,
      43029,
      'Campanha Ocidental',
      4306,
      'Sudoeste Rio-grandense',
    ],
    [
      258,
      'Hb',
      'Canela',
      4304408,
      43024,
      'Gramado-Canela',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      259,
      'Hb',
      'Lajeado',
      4311403,
      43021,
      'Lajeado-Estrela',
      4304,
      'Centro Oriental Rio-grandense',
    ],
    [
      260,
      'Hb',
      'Farroupilha',
      4307906,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
    ],
    [
      261,
      'Hb',
      'Farroupilha',
      4307906,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
    ],
    [
      262,
      'Hb',
      'Viamão',
      4323002,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      263,
      'Hb',
      'Novo Hamburgo',
      4313409,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      264,
      'Hb',
      'Santa Cruz do Sul',
      4316808,
      43020,
      'Santa Cruz do Sul',
      4304,
      'Centro Oriental Rio-grandense',
    ],
    [
      265,
      'Hb',
      'São Francisco de Paula',
      4318200,
      43015,
      'Vacaria',
      4302,
      'Nordeste Rio-grandense',
    ],
    [
      266,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      267,
      'Hb',
      'Caxias do Sul',
      4305108,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
    ],
    [
      268,
      'Hb',
      'Erebango',
      4306973,
      43004,
      'Erechim',
      4301,
      'Noroeste Rio-grandense',
    ],
    [
      269,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      270,
      'Hb',
      'Canoas',
      4304606,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      271,
      'Hb',
      'Encruzilhada do Sul',
      4306908,
      43032,
      'Serras de Sudeste',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      272,
      'Hb',
      'São Leopoldo',
      4318705,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      273,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      274,
      'Hb',
      'Alvorada',
      4300604,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      275,
      'Hb',
      'Canoas',
      4304606,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      276,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      277,
      'Hb',
      'Santana do Livramento',
      4317103,
      43030,
      'Campanha Central',
      4306,
      'Sudoeste Rio-grandense',
    ],
    [
      278,
      'Hb',
      'Erechim',
      4307005,
      43004,
      'Erechim',
      4301,
      'Noroeste Rio-grandense',
    ],
    [
      279,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      280,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      281,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      282,
      'Hb',
      'Cachoeira do Sul',
      4303004,
      43022,
      'Cachoeira do Sul',
      4304,
      'Centro Oriental Rio-grandense',
    ],
    [
      283,
      'Hb',
      'Rio Grande',
      4315602,
      43035,
      'Litoral Lagunar',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      284,
      'Hb',
      'Rio Grande',
      4315602,
      43035,
      'Litoral Lagunar',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      285,
      'Hb',
      'Canela',
      4304408,
      43024,
      'Gramado-Canela',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      286,
      'Hb',
      'Pelotas',
      4314407,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      287,
      'Hb',
      'Santa Maria',
      4316907,
      43018,
      'Santa Maria',
      4303,
      'Centro Ocidental Rio-grandense',
    ],
    [
      288,
      'Hb',
      'Capão do Leão',
      4304663,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      289,
      'Hb',
      'Balneário Pinhal',
      4301636,
      43027,
      'Osório',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      290,
      'Hb',
      'Marau',
      4311809,
      43010,
      'Passo Fundo',
      4301,
      'Noroeste Rio-grandense',
    ],
    [
      291,
      'Hb',
      'Viamão',
      4323002,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      292,
      'Hb',
      'Encantado',
      4306809,
      43021,
      'Lajeado-Estrela',
      4304,
      'Centro Oriental Rio-grandense',
    ],
    [
      293,
      'Hb',
      'Rio Grande',
      4315602,
      43035,
      'Litoral Lagunar',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      294,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      295,
      'Hb',
      'Viamão',
      4323002,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      296,
      'Hb',
      'Caxias do Sul',
      4305108,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
    ],
    [
      297,
      'Hb',
      'Pelotas',
      4314407,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      298,
      'Hb',
      'Viamão',
      4323002,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      299,
      'Hb',
      'Caxias do Sul',
      4305108,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
    ],
    [
      300,
      'Hb',
      'Alvorada',
      4300604,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      301,
      'Hb',
      'Alvorada',
      4300604,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      302,
      'Hb',
      'Capão do Leão',
      4304663,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      303,
      'Hb',
      'Butiá',
      4302709,
      43025,
      'São Jerônimo',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      304,
      'Hb',
      'Igrejinha',
      4310108,
      43024,
      'Gramado-Canela',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      305,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      306,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      307,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      308,
      'Hb',
      'Santa Cruz do Sul',
      4316808,
      43020,
      'Santa Cruz do Sul',
      4304,
      'Centro Oriental Rio-grandense',
    ],
    [
      309,
      'Hb',
      'Esteio',
      4307708,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      310,
      'Hb',
      'Gravataí',
      4309209,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      311,
      'Hb',
      'Montenegro',
      4312401,
      43023,
      'Montenegro',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      312,
      'Hb',
      'Panambi',
      4313904,
      43008,
      'Ijuí',
      4301,
      'Noroeste Rio-grandense',
    ],
    [
      313,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      314,
      'Hb',
      'São Jerônimo',
      4318408,
      43025,
      'São Jerônimo',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      315,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      316,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      317,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      318,
      'Hb',
      'Camaquã',
      4303509,
      43028,
      'Camaquã',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      319,
      'Hb',
      'Santa Cruz do Sul',
      4316808,
      43020,
      'Santa Cruz do Sul',
      4304,
      'Centro Oriental Rio-grandense',
    ],
    [
      320,
      'Hb',
      'Santa Maria',
      4316907,
      43018,
      'Santa Maria',
      4303,
      'Centro Ocidental Rio-grandense',
    ],
    [
      321,
      'Hb',
      'Caxias do Sul',
      4305108,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
    ],
    [
      322,
      'Hb',
      'Bento Gonçalves',
      4302105,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
    ],
    [
      323,
      'Hb',
      'Uruguaiana',
      4322400,
      43029,
      'Campanha Ocidental',
      4306,
      'Sudoeste Rio-grandense',
    ],
    [
      324,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      325,
      'Hb',
      'Caxias do Sul',
      4305108,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
    ],
    [
      326,
      'Hb',
      'Cambará do Sul',
      4303608,
      43015,
      'Vacaria',
      4302,
      'Nordeste Rio-grandense',
    ],
    [
      327,
      'Hb',
      'São Leopoldo',
      4318705,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      328,
      'Hb',
      'Bagé',
      4301602,
      43031,
      'Campanha Meridional',
      4306,
      'Sudoeste Rio-grandense',
    ],
    [
      329,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      330,
      'Hb',
      'Taquara',
      4321204,
      43024,
      'Gramado-Canela',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      331,
      'Hb',
      'Canoas',
      4304606,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      332,
      'Hb',
      'Flores da Cunha',
      4308201,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
    ],
    [
      333,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      334,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      335,
      'Hb',
      'Garibaldi',
      4308607,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
    ],
    [
      336,
      'Hb',
      'São José do Norte',
      4318507,
      43035,
      'Litoral Lagunar',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      337,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      338,
      'Hb',
      'Passo Fundo',
      4314100,
      43010,
      'Passo Fundo',
      4301,
      'Noroeste Rio-grandense',
    ],
    [
      339,
      'Hb',
      'Igrejinha',
      4310108,
      43024,
      'Gramado-Canela',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      340,
      'Hb',
      'Marau',
      4311809,
      43010,
      'Passo Fundo',
      4301,
      'Noroeste Rio-grandense',
    ],
    [
      341,
      'Hb',
      'Canoas',
      4304606,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      342,
      'Hb',
      'Caxias do Sul',
      4305108,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
    ],
    [
      343,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      344,
      'Hb',
      'Rio Grande',
      4315602,
      43035,
      'Litoral Lagunar',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      345,
      'Hb',
      'Bento Gonçalves',
      4302105,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
    ],
    [
      346,
      'Hb',
      'Bento Gonçalves',
      4302105,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
    ],
    [
      347,
      'Hb',
      'Canoas',
      4304606,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      348,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      349,
      'Hb',
      'Caxias do Sul',
      4305108,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
    ],
    [
      350,
      'Hb',
      'Caxias do Sul',
      4305108,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
    ],
    [
      351,
      'Hb',
      'Dom Pedro de Alcântara',
      4306551,
      43027,
      'Osório',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      352,
      'Hb',
      'Encruzilhada do Sul',
      4306908,
      43032,
      'Serras de Sudeste',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      353,
      'Hb',
      'Lagoa Vermelha',
      4311304,
      43015,
      'Vacaria',
      4302,
      'Nordeste Rio-grandense',
    ],
    [
      354,
      'Hb',
      'Lajeado',
      4311403,
      43021,
      'Lajeado-Estrela',
      4304,
      'Centro Oriental Rio-grandense',
    ],
    [
      355,
      'Hb',
      'Pelotas',
      4314407,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      356,
      'Hb',
      'Pelotas',
      4314407,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      357,
      'Hb',
      'Pelotas',
      4314407,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      358,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      359,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      360,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      361,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      362,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      363,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      364,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      365,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      366,
      'Hb',
      'Santa Cruz do Sul',
      4316808,
      43020,
      'Santa Cruz do Sul',
      4304,
      'Centro Oriental Rio-grandense',
    ],
    [
      367,
      'Hb',
      'Santa Maria',
      4316907,
      43018,
      'Santa Maria',
      4303,
      'Centro Ocidental Rio-grandense',
    ],
    [
      368,
      'Hb',
      'Uruguaiana',
      4322400,
      43029,
      'Campanha Ocidental',
      4306,
      'Sudoeste Rio-grandense',
    ],
    [
      369,
      'Hb',
      'Vacaria',
      4322509,
      43015,
      'Vacaria',
      4302,
      'Nordeste Rio-grandense',
    ],
    [
      370,
      'Hb',
      'Viamão',
      4323002,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      371,
      'Hb',
      'Lajeado',
      4311403,
      43021,
      'Lajeado-Estrela',
      4304,
      'Centro Oriental Rio-grandense',
    ],
    [
      372,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      373,
      'Hb',
      'Estação',
      4307559,
      43004,
      'Erechim',
      4301,
      'Noroeste Rio-grandense',
    ],
    [
      374,
      'Hb',
      'Gravataí',
      4309209,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      375,
      'Hb',
      'Alegrete',
      4300406,
      43029,
      'Campanha Ocidental',
      4306,
      'Sudoeste Rio-grandense',
    ],
    [
      376,
      'Hb',
      'Santa Maria',
      4316907,
      43018,
      'Santa Maria',
      4303,
      'Centro Ocidental Rio-grandense',
    ],
    [
      377,
      'Hb',
      'Pelotas',
      4314407,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      378,
      'Hb',
      'Pelotas',
      4314407,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      379,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      380,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      381,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      382,
      'Hb',
      'Santa Maria',
      4316907,
      43018,
      'Santa Maria',
      4303,
      'Centro Ocidental Rio-grandense',
    ],
    [
      383,
      'Hb',
      'Bento Gonçalves',
      4302105,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
    ],
    [
      384,
      'Hb',
      'Charqueadas',
      4305355,
      43025,
      'São Jerônimo',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      385,
      'Hb',
      'Uruguaiana',
      4322400,
      43029,
      'Campanha Ocidental',
      4306,
      'Sudoeste Rio-grandense',
    ],
    [
      386,
      'Hb',
      'Gravataí',
      4309209,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      387,
      'Hb',
      'Viamão',
      4323002,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      388,
      'Hb',
      'Guaíba',
      4309308,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      389,
      'Hb',
      'Amaral Ferrador',
      4300638,
      43032,
      'Serras de Sudeste',
      4307,
      'Sudeste Rio-grandense',
    ],
    [
      390,
      'Hb',
      'Marau',
      4311809,
      43010,
      'Passo Fundo',
      4301,
      'Noroeste Rio-grandense',
    ],
    [
      391,
      'Hb',
      'Alvorada',
      4300604,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      392,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      393,
      'Hb',
      'Canoas',
      4304606,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      394,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      395,
      'Hb',
      'São Leopoldo',
      4318705,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      396,
      'Hb',
      'Novo Hamburgo',
      4313409,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      397,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      398,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      399,
      'Hb',
      'Caraá',
      4304713,
      43027,
      'Osório',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      400,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      401,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      402,
      'Hb',
      'Santana do Livramento',
      4317103,
      43030,
      'Campanha Central',
      4306,
      'Sudoeste Rio-grandense',
    ],
    [
      403,
      'Hb',
      'Porto Alegre',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      404,
      'Hb',
      'Cachoeirinha',
      4303103,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
    [
      405,
      'Hb',
      'Canoas',
      4304606,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
    ],
  ],
};

export default dataExample;
